import type { Router } from "vue-router";

import type { useSessionStore } from "@/entities/session";
import { setUnauthorizedHandler } from "@/shared/api";
import { safeReturnPath } from "@/shared/lib";

type SessionStore = ReturnType<typeof useSessionStore>;

/**
 * Wiring 401-seam (ADR-0006 D4). `shared/api` лише експонує seam
 * (`setUnauthorizedHandler`) — конкретний handler потребує router (`app`) і
 * session-стору (`entities`), що для `shared` було б upward-import. Тому handler
 * реєструє composition root (`app/providers`), а `shared` нічого з `entities`/`app`
 * не імпортує — FE-аналог driven-port (FSD-межа тримається).
 *
 * Response-interceptor УЖЕ навішений у `httpClient` (ADR-0010) — тут лише
 * реєстрація handler, повторно `installAuthResponseInterceptor` НЕ викликаємо.
 *
 * Handler: `reset()` (скинути сесію) + мʼякий редірект на `/login?return=<safe>`.
 * `safeReturnPath` поверх поточного шляху — defense-in-depth проти open-redirect.
 * «Сесію завершено»-hint — follow-up власника (поза скоупом ітер.2).
 */
export function installAuthShell({
  router,
  session,
}: {
  router: Router;
  session: SessionStore;
}): void {
  setUnauthorizedHandler(() => {
    session.reset();
    const ret = safeReturnPath(router.currentRoute.value.fullPath);
    void router.push({ name: "login", query: { return: ret } });
  });
}
